import React from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import styles from "./callhistory.module.css";
import { formatPhone, formatRoomTime, statusOf } from "./callhistoryformat";
import { formatDuration } from "../phoneinbound/receiverrow";

const statusClass : { [kind : string] : string } = {
    callback : styles.statusCallback,
    manual : styles.statusManual,
    incall : styles.statusIncall,
    done : styles.statusDone,
    noanswer : styles.statusNoanswer,
    waiting : styles.statusWaiting,
    hidden : styles.statusHidden,
    none : styles.statusNone
};

//좌측 표 한 행: 고객(이름+재원칩) / 상태 2줄 / 최근 / 댓글
const ContactRow : React.FC<any> = (props) => {
    const c = props.contact;
    const status = statusOf(c, props.now, formatDuration);
    const isCallback = !c.hidden && !!c.callbackNeeded;
    const rowClass = [
        styles.row,
        isCallback ? styles.rowCallback : "",
        props.selected ? styles.rowSelected : "",
        c.hidden ? styles.rowHidden : ""
    ].join(" ");

    return (
        <tr className={rowClass} onClick={() => props.onSelect(c.phoneNumber)}>
            <td>
                <div className={`${styles.name} ${isCallback ? styles.nameCallback : ""}`} title={formatPhone(c.phoneNumber)}>
                    {c.displayName || formatPhone(c.phoneNumber)}
                    {c.isEnrolled ? <span className={styles.enrolledChip}>재원</span> : ""}
                </div>
            </td>
            <td>
                <div className={`${styles.statusLine1} ${statusClass[status.kind] || ""}`}>{status.line1}</div>
                {status.line2 ? <div className={styles.statusLine2}>{status.line2}</div> : ""}
            </td>
            <td className={`${styles.recent} ${isCallback ? styles.recentCallback : ""}`}>
                {formatRoomTime(c.lastContactAt)}
            </td>
            <td className={styles.commentCell}>
                <span
                    className={`${styles.commentBtn} ${c.commentCount > 0 ? styles.commentBtnActive : ""}`}
                    onClick={(e) => { e.stopPropagation(); props.onComment(c); }}
                    title="댓글"
                >
                    {c.commentCount > 0 ? <span>{c.commentCount}</span> : ""}
                    <ChatBubbleOutlineIcon sx={{ fontSize: 16 }} />
                </span>
            </td>
        </tr>
    );
};

export default React.memo(ContactRow, (prev, next) => {
    if (prev.contact !== next.contact || prev.selected !== next.selected) return false;
    //통화중/콜백 경과 표시가 있는 행만 1초 틱에 반응, 나머지는 분 단위로만
    const live = !!next.contact.inCallSince;
    if (live) return prev.now === next.now;
    return Math.floor(prev.now / 60000) === Math.floor(next.now / 60000);
});
